import React, { ChangeEvent, useState, useEffect } from 'react';
import styles from './Verify.module.scss';

function VerificationInput(props: {
  value: string;
  label: string;
  placeholder: string;
  errorMessage: string;
  onChange: (value: string) => void;
  onResend: () => void;
  resetInputError: () => void;
}) {
  const [resendCountdown, setResendCountdown] = useState(0);
  const {
    value, label, placeholder, errorMessage, onChange, onResend, resetInputError,
  } = props;

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    resetInputError();
    onChange(event.target.value);
  };

  const countDown = () => {
    setResendCountdown(resendCountdown - 1);
  };

  const handleResend = () => {
    setResendCountdown(30);
    onResend();
  };

  useEffect(() => {
    if (resendCountdown) {
      setTimeout(countDown, 1000);
    }
  }, [resendCountdown]);

  return (
    <div className={styles.inputContainer}>
      <label htmlFor="verificationCode">
        {label}
        <div className={` ${styles.inputWithResend} ${errorMessage !== '' ? styles.inputError : ''}`}>
          <input
            type="text"
            value={value}
            name="verificationCode"
            placeholder={placeholder}
            maxLength={10}
            minLength={4}
            onChange={handleOnChange}
          />
          <button
            type="button"
            className={styles.resend}
            disabled={resendCountdown > 0}
            onClick={handleResend}
          >
            {resendCountdown ? `Resent (${resendCountdown})` : 'Resend'}
          </button>
        </div>
      </label>
      <p className={styles.errorMessage}>{errorMessage}</p>
    </div>
  );
}

export default VerificationInput;
